import React from "react";

const Engineering: React.FC = () => {
  return (
    <div className="section">
      <p>
        I currently work at <a href="https://www.appliedintuition.com/">Applied Intuition</a> helping build the next generation of AI for physical systems.
      </p>
    </div>
  );
};

export default Engineering;
